// extracted by mini-css-extract-plugin
export default {"star":"FallingStars_star__JYIdN","twinkle":"FallingStars_twinkle__D6hY6"};